//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[0,"AdjustFeedRateOption",1,0],[0,"CornerControlMethod",1,0],[1,"FilletingRadius",0,"CAM.InheritableToolDepBuilder",0],[1,"MaxCompensationFactor",0,"CAM.InheritableDoubleBuilder",0],[1,"MaximumCornerAngle",0,"CAM.InheritableDoubleBuilder",0],[1,"MinCompensationFactor",0,"CAM.InheritableDoubleBuilder",0],[1,"MinimumCornerAngle",0,"CAM.InheritableDoubleBuilder",0],[0,"NumberOfSteps",1,0],[1,"PreviousToolDiameter",0,"CAM.InheritableDoubleBuilder",0],[0,"SlowdownDistanceOption",1,0],[1,"SlowdownPercent",0,"CAM.InheritableDoubleBuilder",0],[0,"SmoothCornersAt",1,0],[0,"SmoothingOption",1,0],[1,"ToolDiameterPercent",0,"CAM.InheritableDoubleBuilder",0]],[],[]];
SPLM.CAM.CornerControlBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.CornerControlBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.CornerControlBuilder.CornerControlMethods = Object.freeze({
    "RollAround" : "RollAround", "ExtendAndTrim" : "ExtendAndTrim", "Extend" : "Extend"});

SPLM.CAM.CornerControlBuilder.SmoothingOptions = Object.freeze({
    "None" : "None", "AllPasses" : "AllPasses", "AllButLastPass" : "AllButLastPass"});

SPLM.CAM.CornerControlBuilder.AdjustFeedRateOptions = Object.freeze({
    "None" : "None", "OnAllArcs" : "OnAllArcs"});

SPLM.CAM.CornerControlBuilder.SlowdownDistanceOptions = Object.freeze({
    "None" : "None", "CurrentTool" : "CurrentTool", "PreviousTool" : "PreviousTool"});

SPLM.CAM.CornerControlBuilder.SmoothCornersAtOptions = Object.freeze({
    "Boundary" : "Boundary", "PartSurface" : "PartSurface", "BoundaryAndPartSurface" : "BoundaryAndPartSurface"});

export default SPLM;